import { RangeDateTypeHr } from 'src/types/date.type';
import { PagedList } from 'src/types/pagedList.type';
import { HandoverTicketAdd, IHandoverTicket } from 'src/types/office_ticket/handoverTicket.type';
import { ITicketParams } from 'src/types/params.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/handover-tickets';

export const getHandoverTickets = async (params: ITicketParams) => {
  return await http.get<PagedList<IHandoverTicket>>(`${controller}`, {
    params: params
  });
};

export const getHandoverTicketsConfirm = async (params: ITicketParams) => {
  return await http.get<PagedList<IHandoverTicket>>(`${controller}/waiting-confirm`, {
    params: params
  });
};

export const getHandoverTicket = async (id: number) => {
  return await http.get<IHandoverTicket>(`${controller}/${id}`);
};

export const addHandoverTicket = async (handoverTicket: HandoverTicketAdd) => {
  return await http.post(controller, handoverTicket);
};

export const updateHandoverTicket = async (id: number, handoverTicket: HandoverTicketAdd) => {
  return await http.put(`${controller}/${id}`, handoverTicket);
};

export const cancelHandoverTicket = async (id: number) => {
  return await http.put(`${controller}/${id}/cancel`);
};

export const confirmHandoverTickets = async (id?: number) => await http.put(`${controller}/${id}/confirm`, { id: id });

export const printHandoverTicket = async (id: number) =>
  await http.get(`${controller}/print`, {
    params: {
      id: id
    },
    responseType: 'blob'
  });

export const cancelApprovalHandoverTickets = async (id: string, step: number) =>
  await http.put(`${controller}/${id}/cancel-approval`, { step });

export const getMyHandoverTicketCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-my-tickets`, {
    params: params
  });
};
export const getHandoverTicketApprovalCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-handle-tickets`, {
    params: params
  });
};

export const getHandoverTicketWaitingProcessingCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-ticket-waiting-processing`, {
    params: params
  });
};
